"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _iconButton = _interopRequireDefault(require("../icon-button/icon-button.style"));

var _sidebar = require("./sidebar.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SidebarStyle = _styledComponents.default.div`
  ${({
  onCancel,
  position,
  size,
  theme
}) => (0, _styledComponents.css)`
    background-color: ${theme.disabled.input};
    border-radius: 1px;
    bottom: 0;
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    z-index: ${theme.zIndex.fullScreenModal};

    ${size && (0, _styledComponents.css)`
      width: ${_sidebar.SIDEBAR_SIZES_CSS[size]};
    `}

    ${position && (0, _styledComponents.css)`
      box-shadow: ${theme.shadows.depth3};
      ${position}: 0;
    `}

    ${onCancel && (0, _styledComponents.css)`
      > ${_iconButton.default}:first-of-type {
        position: absolute;
        z-index: 1;
        right: 25px;
        top: 25px;
      }
    `}
  `}
`;
SidebarStyle.defaultProps = {
  theme: _base.default
};
var _default = SidebarStyle;
exports.default = _default;